module.exports = __webpack_public_path__ + "img/christian-viqueira-byn.b4774b09.jpg";